export const ADMIN_TYPE = {
    RIDERY: 0,
    INAC: 1,
    OPERATOR: 2,
}

export const ADMIN_TEXT = {
    0: "Administrador",
    1: "Inac",
    2 :"Operador"
}

export const ADMIN_STATUS = {
    ACTIVE: true,
    INACTIVE: false,
}

export const FLIGHT_STATUS = {
    PENDING: 1,
    PROGRAMED: 2,
    COMPLETED: 3,
    CANCELED: 4,
}

export const FLIGHT_ROUTE_STATUS = {
    ACTIVE: true,
    INACTIVE: false,
}

export const AIRPLANE_STATUS = {
    ACTIVE: true,
    INACTIVE: false,
}

export const AIRPORT_STATUS = {
    ACTIVE: true,
    INACTIVE: false,
}

export const EMPTY_LEGS_TIME_SCHEDULES = {
    MORNING: 1,
    AFTERNOON: 2,
    EVENING: 3,
}

export const EMPTY_LEGS_STATUS = {
    ACTIVE: 1,
    INACTIVE: 2,
    EXPIRED: 3,
}

export const EMPTY_LEGS_BUYERS_STATUS = {
    PENDING: 1,
    CANCELED: 2,
    COMPLETED: 3,
}

export const RIDERY_FLY_USER_CREATED_IN = {
    FLY: 1,
    RIDERY: 2,
}

export const OPERATOR_REQUEST_STATUS = {
    PENDING: 1,
    COMPLETED: 2,
    CANCELED: 3,
}